import { Dispatch } from 'redux';
import StorageContants from '../../config/storage.constants';
import { LocalStorage } from '../../customer-call-sdk';
import * as CustomerNumberAPI from '../../services/customer-number.service';
import * as CustomerFeatureAPI from '../../services/customer-feature.service';
import { CustomerNumber, UUID } from '../../types';
import { CustomerFeature } from '../../types/customer-feature.type';

import {
    GetCustomerFeaturesAction,
    GetCustomerFeaturesErrorAction,
    GetCustomerFeaturesSuccessAction,
    GetCustomerNumbersAction,
    GetCustomerNumbersErrorAction,
    GetCustomerNumbersSuccessAction,
    GET_CUSTOMER_FEATURES,
    GET_CUSTOMER_FEATURES_ERROR,
    GET_CUSTOMER_FEATURES_SUCCESS,
    GET_CUSTOMER_NUMBERS,
    GET_CUSTOMER_NUMBERS_ERROR,
    GET_CUSTOMER_NUMBERS_SUCCESS,
    HideNumberSelectionDialogAction,
    HIDE_NUMBER_SELECTION_DIALOG,
    SetActiveCustomerNumberAction,
    SET_ACTIVE_CUSTOMER_NUMBER,
    ShowNumberSelectionDialogAction,
    SHOW_NUMBER_SELECTION_DIALOG,
    // SetCustomerNameAction,
    // SET_CUSTOMER_NAME,
} from './types';

export const setActiveCustomerNumber = (
    customerNumber: CustomerNumber,
): SetActiveCustomerNumberAction => {
    LocalStorage.set(StorageContants.ACTIVE_CUSTOMER_NUMBER, customerNumber.number);
    return {
        type: SET_ACTIVE_CUSTOMER_NUMBER,
        payload: {
            customerNumber,
        },
    };
};

export const getCustomerNumberSuccess = (
    customerNumbers: CustomerNumber[],
): GetCustomerNumbersSuccessAction => {
    return {
        type: GET_CUSTOMER_NUMBERS_SUCCESS,
        payload: {
            customerNumbers,
        },
    };
};

export const getCustomerNumberError = (error: any): GetCustomerNumbersErrorAction => {
    return {
        type: GET_CUSTOMER_NUMBERS_ERROR,
        payload: {
            error,
        },
    };
};

export const getCustomerNumbers = (usedId: UUID) => async (
    dispatch: Dispatch<
        | GetCustomerNumbersAction
        | GetCustomerNumbersSuccessAction
        | GetCustomerNumbersErrorAction
        | SetActiveCustomerNumberAction
    >,
) => {
    dispatch({ type: GET_CUSTOMER_NUMBERS });
    const { data, error } = await CustomerNumberAPI.getCustomerNumber(usedId);
    if (data) {
        const { customerNumbers } = data;
        dispatch(getCustomerNumberSuccess(customerNumbers));

        const activeNumber = LocalStorage.get(StorageContants.ACTIVE_CUSTOMER_NUMBER);

        customerNumbers.sort((customerNumber) => {
            return customerNumber.numberTypeId === 'twilio' ? -1 : 1;
        });

        const activeCustomerNumber = customerNumbers.find(
            (customerNumber) => customerNumber.number === activeNumber,
        );

        const isTwilioNumberPresent = customerNumbers.filter(
            (customerNumber) => customerNumber.numberTypeId === 'twilio',
        );

        if (isTwilioNumberPresent.length <= 0) {
            console.log('isTwilioNumberPresent');
            customerNumbers.sort((customerNumber) => {
                return customerNumber.numberTypeId === 'vri' ? -1 : 1;
            });
            const vriCustomerNumbers = customerNumbers.filter(
                (customerNumber) => customerNumber.numberTypeId === 'vri',
            );
            if (vriCustomerNumbers.length > 0) {
                console.log('vriCustomerNumbers', vriCustomerNumbers);
                dispatch(setActiveCustomerNumber(vriCustomerNumbers[0]));
            }
        }

        if (!activeCustomerNumber && customerNumbers.length > 0) {
            dispatch(setActiveCustomerNumber(customerNumbers[0]));
        } else if (activeCustomerNumber) {
            dispatch(setActiveCustomerNumber(activeCustomerNumber));
        }
    }
    if (error) {
        dispatch(getCustomerNumberError(error));
    }
};

export const showNumberSelectionDialog = (): ShowNumberSelectionDialogAction => {
    return {
        type: SHOW_NUMBER_SELECTION_DIALOG,
    };
};

export const hideNumberSelectionDialog = (): HideNumberSelectionDialogAction => {
    return {
        type: HIDE_NUMBER_SELECTION_DIALOG,
    };
};

export const getCustomerFeatureSuccess = (
    features: CustomerFeature,
): GetCustomerFeaturesSuccessAction => {
    return {
        type: GET_CUSTOMER_FEATURES_SUCCESS,
        payload: {
            features,
        },
    };
};

export const getCustomerFeatureError = (error: string): GetCustomerFeaturesErrorAction => {
    return {
        type: GET_CUSTOMER_FEATURES_ERROR,
        payload: {
            error,
        },
    };
};

export const getCustomerFeature = (userId: UUID) => async (
    dispatch: Dispatch<
        | GetCustomerFeaturesAction
        | GetCustomerFeaturesSuccessAction
        | GetCustomerFeaturesErrorAction
    >,
) => {
    dispatch({ type: GET_CUSTOMER_FEATURES });
    const { data, error } = await CustomerFeatureAPI.getCustomerFeature(userId);
    if (data) {
        dispatch(getCustomerFeatureSuccess(data.customerFeature));
    }
    if (error) {
        dispatch(getCustomerFeatureError(error));
    }
};
